import { stringToParsedTokenArray } from "./eram/eramMessaging.js";
const _normalPidResponseMsgTypes = [
    "DM6",
    "DM7",
    "DM8",
    "DM9",
    "DM10",
    "DM18",
    "DM22",
];
export const normalPidResponseMsgTypes = _normalPidResponseMsgTypes;
export function isSupportedNormalPidResponseMsgType(msgType) {
    return normalPidResponseMsgTypes.includes(msgType);
}
export function createNormalPidResponse(callsign, msg) {
    const msgType = msg.elements[0].type;
    const params = msg.elements[0].parameters;
    if (!isSupportedNormalPidResponseMsgType(msgType)) {
        return null;
    }
    switch (msgType) {
        case "DM6":
        case "DM8":
        case "DM9":
        case "DM10":
            return stringToParsedTokenArray(`QZ ${params[0]} /U ${callsign}`);
        case "DM7":
            return stringToParsedTokenArray(`QZ ${params[0]}B${params[1]} /U ${callsign}`);
        case "DM18":
            return stringToParsedTokenArray(`QS /${params[0]} /U ${callsign}`);
        case "DM22":
            return stringToParsedTokenArray(`QU ${params[0]} /U ${callsign}`);
        default:
            return null;
    }
}
/* these responses are not with a command and the cpdlc message is instead generated by the server
 * without a generated ERAM command
 */
export const _supportedPidResponseMsgTypes = ["DM15", "DM27"];
export const supportedPidResponseMsgTypes = _supportedPidResponseMsgTypes;
export function isSupportedPidResponseMsgType(msgType) {
    return supportedPidResponseMsgTypes.includes(msgType);
}
//# sourceMappingURL=createNormalPidResponse.js.map